/* MavoStudio – Newsletter-Pop-up (sections/mavo-newsletter-popup.liquid)
   Öffnet nach der eingestellten Zeit, merkt sich „geschlossen“ bzw. „angemeldet“ im Browser
   (dauerhaft nur mit erlaubten Präferenz-Cookies, sonst nur für die Sitzung).
   Der 10-%-Code steht nicht hier: Er kommt erst nach der Bestätigung per Willkommensmail. */
(() => {
  const KEY = 'mavo-nl-popup';
  const SENT = KEY + '-sent';
  const html = document.documentElement;

  const prefsAllowed = () => {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.preferencesProcessingAllowed()); } catch (e) { return false; }
  };
  const read = () => {
    for (const store of ['localStorage', 'sessionStorage']) {
      try { const v = JSON.parse(window[store].getItem(KEY) || 'null'); if (v) return v; } catch (e) {}
    }
    return null;
  };

  const init = (dlg) => {
    if (!dlg || dlg.dataset.mavoReady) return;
    dlg.dataset.mavoReady = '1';
    const designMode = dlg.dataset.designMode === 'true';
    const sectionId = dlg.dataset.sectionId;
    const days = Number(dlg.dataset.days) || 14;
    const delay = (Number(dlg.dataset.delay) || 8) * 1000;
    const stateEl = dlg.querySelector('[data-state]');
    const state = stateEl ? stateEl.dataset.state : 'form';

    const remember = (value) => {
      if (designMode) return;
      try { sessionStorage.setItem(KEY, JSON.stringify(value)); } catch (e) {}
      if (prefsAllowed()) { try { localStorage.setItem(KEY, JSON.stringify(value)); } catch (e) {} }
    };
    const open = () => {
      if (dlg.open || !dlg.isConnected) return;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      html.classList.add('mavo-nlp-lock');
      const title = dlg.querySelector('.mavo-nlp__title');
      if (title) title.focus({ preventScroll: true });
    };
    const close = (pause) => {
      if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
      html.classList.remove('mavo-nlp-lock');
      if (pause) remember({ until: Date.now() + days * 864e5 });
    };
    const pause = state !== 'success';

    dlg.addEventListener('close', () => html.classList.remove('mavo-nlp-lock'));
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); close(pause); });
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(pause); });
    dlg.querySelectorAll('[data-mavo-nlp-close]').forEach((btn) => btn.addEventListener('click', () => close(pause)));

    const form = dlg.querySelector('form');
    if (form) form.addEventListener('submit', () => { try { sessionStorage.setItem(SENT, '1'); } catch (e) {} });

    if (designMode) {
      // Theme-Editor: Pop-up zeigen, solange der Abschnitt ausgewählt ist
      document.addEventListener('shopify:section:select', (e) => { if (e.detail.sectionId === sectionId) open(); });
      document.addEventListener('shopify:section:deselect', (e) => { if (e.detail.sectionId === sectionId) close(false); });
      return;
    }

    const posted = new URLSearchParams(location.search).get('customer_posted') === 'true';
    let sentHere = false;
    try { sentHere = sessionStorage.getItem(SENT) === '1'; } catch (e) {}
    const fromPopup = location.hash === '#' + dlg.dataset.formId || sentHere;

    if (state === 'success' || (posted && state !== 'error')) {
      // angemeldet (über Pop-up oder Fußzeile): Pop-up nicht wieder automatisch zeigen
      remember({ subscribed: true });
      try { sessionStorage.removeItem(SENT); } catch (e) {}
      if (fromPopup && state === 'success') open();
      return;
    }
    if (state === 'error' && fromPopup) { open(); return; }

    const saved = read();
    if (saved && (saved.subscribed || (saved.until && saved.until > Date.now()))) return;

    // nicht über Cookie-Banner, Warenkorb-Schublade oder Menü legen – dann kurz warten
    const busy = () => {
      const banner = document.getElementById('shopify-pc__banner');
      if (banner && banner.offsetParent !== null) return true;
      if (/overflow-hidden/.test(document.body.className)) return true;
      return !!document.querySelector('dialog[open]');
    };
    let tries = 0;
    const attempt = () => {
      if (busy() && tries++ < 40) { setTimeout(attempt, 3000); return; }
      if (!busy()) open();
    };
    setTimeout(attempt, delay);
  };

  // Newsletter-Felder der Fußzeile/Startseite: Einwilligungshinweis ergänzen, Erfolgsmeldung auf Double-Opt-in anpassen
  const enhanceForms = () => {
    const tpl = document.getElementById('MavoNlFooterHint');
    if (!tpl) return;
    const footerForm = document.getElementById('ContactFooter');
    if (footerForm && tpl.innerHTML.trim() && !footerForm.querySelector('.mavo-nl-hint')) {
      const hint = document.createElement('div');
      hint.className = 'mavo-nl-hint';
      hint.innerHTML = tpl.innerHTML;
      const field = footerForm.querySelector('.newsletter-form__field-wrapper');
      if (field) field.after(hint); else footerForm.appendChild(hint);
    }
    const success = tpl.dataset.success;
    if (success) {
      document.querySelectorAll('.newsletter-form__message--success').forEach((el) => {
        const icon = el.querySelector('.svg-wrapper');
        el.textContent = '';
        if (icon) el.appendChild(icon);
        el.append(success);
      });
    }
  };

  enhanceForms();
  document.querySelectorAll('dialog.mavo-nlp').forEach(init);
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('dialog.mavo-nlp')));
})();